export default "__VITE_PUBLIC_ASSET__4b53056f__"